import { BookingState } from '../booking-state/BookingState';
import { Steps } from './Steps';
import { PageRoutes } from '../navigation/PageRoutes';

export function getPageByStep(step: Steps, bookingState: BookingState, _currentStep?: Steps): PageRoutes | null {
  switch (step) {
    case Steps.Bookings: {
      if (!bookingState.bookingsCount || bookingState.bookingsCount === 1) {
        return null;
      }

      return PageRoutes.Bookings;
    }
    case Steps.YourVehicle:
      return PageRoutes.VehicleDetails;
    case Steps.SelectService:
      return PageRoutes.ServiceRequest;
    case Steps.SelectDealer:
      return PageRoutes.SelectDealer;
    // case Steps.EstimatedPrice: {
    //   const estimationPage = getEstimationPage(bookingState);
    //
    //   if (estimationPage) {
    //     return estimationPage;
    //   }
    //
    //   if (!currentStep) {
    //     return null;
    //   }
    //
    //   if (currentStep === Steps.Appointment) {
    //     return PageRoutes.SelectDealer;
    //   }
    //
    //   return PageRoutes.SelectServiceDate;
    // }
    case Steps.Appointment:
      return PageRoutes.SelectServiceDate;
    //case Steps.CollectionAndDelivery:
    //  return PageRoutes.SelectCollectionDeliveryOptions;
    case Steps.ContactDetails:
      return PageRoutes.CustomerContact;
    case Steps.ReviewAndSubmit:
      return PageRoutes.VerifyBookingDetails;
    default:
      return null;
  }
}
